module.exports = __webpack_public_path__ + "media/images/categories/icon_cat13-b2c8adbbf66bad2346741b06ccdea0cd.svg";